import angular from 'angular';

export default angular
  .module('books.util.BarcodeValidator', [])
  .factory('BarcodeValidator', BarcodeValidatorFactory)
  .name;

BarcodeValidatorFactory.$inject = [];

/* @ngInject */ function BarcodeValidatorFactory() {
  function Validator() {
  /***************************************************************************
   * Constants
   ***************************************************************************/
  /** Regex Expression used to parse the receipt barcode.
      <p>Groups</p>
      <ol>
        <li>Type (CR), (PO) or empty string.</li>
        <li>"[Batch-]Receipt" number.</li>
        <li>Batch Number if group 4 contains a value, Receipt/Customer
            number otherwise.</li>
        <li>Receipt Number or empty string.</li>
      </ol> */
    var REX_BARCODE = '^(?:\\*+)?(?:(CR|PO)-)?((\\d+)(?:-(\\w+))?)(?:\\*+)?$';
    var REO_BARCODE = new RegExp(REX_BARCODE);

    /***************************************************************************
     * Properties
     ***************************************************************************/
    /** Input value. */ this.barcode = '';
    /** Valid barcode flag. */ this.isValid = false;
    /** Receipt number barcode flag. */ this.isReceipt = false;
    /** Purchase Order number barcode flag. */ this.isPO = false;
    /** [Batch-] Receipt Number. */ this.number = '';
    /** Batch Number. */ this.batchNumber = '';
    /** Receipt Number. */ this.receiptNumber = '';

    /***************************************************************************
     * parse */
    /**
     * Parses the input string as a barcode and returns an object of this class.
     *
     * @param  bc  Barcode Input
     ***************************************************************************/
    this.parse = function (bc) {
      this.barcode = bc.trim();
      this.isValid = false;
      this.isReceipt = false;
      this.isPO = false;
      this.number = '';
      this.batchNumber = '';
      this.receiptNumber = '';

      var ra = REO_BARCODE.exec(this.barcode);

      if ((this.isValid = ra != null)) {
        this.number = ra[2];

        /*-------------------------------------------*/
        /* If "CR-" or "Batch-Receipt" number format */
        /* is found, this is a Receipt Number.       */
        /*-------------------------------------------*/
        if (ra[1] || ra[4]) {
          this.isReceipt = true;
          this.batchNumber = ra[4] ? ra[3] : null;
          this.receiptNumber = ra[4] ? ra[4] : ra[3];
        }

        /*-------------------------------------------------------*/
        /* If "PO-" number format is found, this is a PO number. */
        /*-------------------------------------------------------*/
        if (ra[1] == 'PO') this.isPO = true;
      }

      return this;
    };
  }

  return new Validator();
}
